import React, { PropsWithChildren, Suspense } from "react";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import LoadingOverlay from "../../components/LoadingOverlay";

type Props = {
  errorFallback: React.ComponentType<FallbackProps>;
  suspenseFallback?: React.ReactElement;
};

const LoadingAndErrorBoundary: React.FC<PropsWithChildren<Props>> = ({
  children,
  errorFallback,
  suspenseFallback = <LoadingOverlay />
}) => (
  <ErrorBoundary FallbackComponent={errorFallback}>
    <Suspense fallback={suspenseFallback}>{children}</Suspense>
  </ErrorBoundary>
);

export default LoadingAndErrorBoundary;
